import React from "react";
import { Link } from "react-router-dom";
import { hiring } from "../../../Assets";
import { FiGlobe } from "react-icons/fi";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0e1e25] text-white px-6 lg:px-20 py-10">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-left">
          <div>
            <h4 className="text-base font-semibold mb-2 pt-11">Career</h4>
            <ul className="space-y-2 text-sm text-gray-300 pl-0">
              <li>
                <Link to="/joblistings" className="text-gray-500 hover:text-gray-300 no-underline">
                  Job Openings
                </Link>
              </li>
              <li>
                <a
                  href="https://wellfound.com/company/avijo/jobs"
                  target="_blank"
                  rel="noreferrer"
                  onClick={scrollToTop}
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Team
                </a>
              </li>
              <li>
                <a
                  href="https://wellfound.com/company/avijo/jobs"
                  target="_blank"
                  rel="noreferrer"
                  onClick={scrollToTop}
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Locations
                </a>
              </li>
              <li>
                <a
                  href="https://wellfound.com/company/avijo/jobs"
                  target="_blank"
                  rel="noreferrer"
                  onClick={scrollToTop}
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Warehouse jobs
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-2 pt-11">Working with us</h4>
            <ul className="space-y-2 text-sm text-gray-300 pl-0">
              <li>
                <Link
                  onClick={scrollToTop}
                  to="/culture"
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Culture
                </Link>
              </li>
              <li>
                <Link
                  onClick={scrollToTop}
                  to="/support"
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Benefits
                </Link>
              </li>
              <li>
                <Link
                  onClick={scrollToTop}
                  to="/diversity"
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Diversity and Inclusions
                </Link>
              </li>
              <li>
                <Link
                  onClick={scrollToTop}
                  to="/leadership"
                  className="text-gray-500 hover:text-gray-300 no-underline"
                >
                  Leadership Principles
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex justify-center items-center">
          <img src={hiring} alt="Hiring" className="w-[80%] max-w-xs object-contain" />
        </div>
      </div>

      <div className="mt-10 border-t border-gray-700 pt-6 text-center">
        <h2 className="text-white font-semibold" style={{ fontFamily: "Gilroy-SemiBold" }}>avijobs</h2>
        
        <div className="flex justify-center gap-6 mt-4">
          <div className="flex items-center gap-2 text-gray-400 hover:text-white cursor-pointer">
            <FiGlobe className="text-lg" />
            <span>English</span>
          </div>

          <div className="flex items-center gap-2 text-gray-400 hover:text-white cursor-pointer">
            <img src="https://flagcdn.com/in.svg" alt="India Flag" className="w-5 h-5 rounded-sm" />
            <span>India</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
